import { forwardRef } from 'react';

import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

import { PlotSection } from '../plot-section';

import { IntroBox } from './intro-box';
import { OverviewTable } from './overview-table';

export type OverviewSectionProps = {
  filters: IWarrantyRepository.Filters;
};
export const OverviewSection = forwardRef<HTMLDivElement, OverviewSectionProps>(
  function ({ filters }, ref) {
    return (
      <PlotSection sectionName="Overview Table">
        <IntroBox />
        <OverviewTable filters={filters} ref={ref} />
      </PlotSection>
    );
  },
);
OverviewSection.displayName = 'OverviewSection';
